import { Injectable } from '@angular/core';
import { Kvd } from '@delab/ngx-gen-ts-ixserv/models';
import { JsonConvert, OperationMode, ValueCheckingMode } from 'json2typescript';
import { map } from 'rxjs';
import { OrdersApiService } from 'src/.api-client/services/orders-api.service';
import { AbstractCache } from './abstract-cache';

@Injectable({ providedIn: 'root' })
export class KvdsCache extends AbstractCache<Kvd[]> {
    private readonly _jsonConvert: JsonConvert = new JsonConvert(OperationMode.ENABLE, ValueCheckingMode.ALLOW_NULL);

    constructor(private _ordersApiService: OrdersApiService) {
        super();
    }

    protected _getCurrentValue() {
        return this._ordersApiService.kvdsGetKvds().pipe(
            map((serialized) => {
                return this._jsonConvert.deserializeArray(serialized, Kvd);
            }),
        );
    }
}
